import { ButtonList } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../menu.module.scss';
import { MenuItem } from '../types';

interface MenuItemProps {
  item: MenuItem;
  isItemActive: boolean;
  setActiveItem: (item: MenuItem) => void;
}

export const Item = memo(function Item({
  item,
  isItemActive,
  setActiveItem,
}: MenuItemProps): JSX.Element {
  const { segmentId, icon, route, title } = item;
  const navigate = useNavigate();
  const classNames = classnames(styles.menuItem, styles.menuItemControl, {
    [styles.activeButton]: isItemActive,
  });

  function handleClick(): void {
    setActiveItem(item);
    navigate(route);
    ampli.settingsMenuItemClicked({ id: segmentId });
  }

  return (
    <ButtonList.Item
      data-testid={`menu-item-${segmentId}`}
      onClick={handleClick}
      buttonClassName={classNames}
      icon={icon}
    >
      <span className={styles.menuItemOverride}>{title}</span>
    </ButtonList.Item>
  );
},
isEqual);

Item.displayName = 'SettingsMenuMenuItem';
